module.exports = __webpack_public_path__ + "media/components/articlepage/static/loader-fc9100d7e350e7e44601bfcfcae4eec5.svg";